<template>
  <div class="depense-type-bar">
    <div v-if="loading" class="text-center py-5">
      <a-spin size="large" />
    </div>
    <div v-else>
      <div class="chart-header mb-2">
        <h6 class="chart-title">{{ $t("financialStats.depenseByTypeTitle") }}</h6>
        <div class="chart-subtitle text-muted small">{{ $t("financialStats.depenseByTypeSubtitle") }}</div>
      </div>
      <apexchart
        v-if="hasData"
        :options="chartOptions"
        :series="series"
        type="bar"
        height="320"
      />
      <div v-else class="text-muted text-center py-4">{{ $t("financialStats.noData") }}</div>
    </div>
  </div>
</template>

<script>
import { getBuildingCurrency } from "@/utilities/countrySpecific";

export default {
  name: "DepenseTypeBarChart",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currency: null,
    };
  },
  created() {
    this.currency = getBuildingCurrency();
  },
  computed: {
    hasData() {
      return this.items && this.items.length > 0;
    },
    labels() {
      return (this.items || []).map((i) => this.formatLabel(i.name));
    },
    series() {
      return [
        {
          name: this.$t("financialStats.amount"),
          data: (this.items || []).map((i) => Number(i.total) || 0),
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "bar",
          toolbar: { show: true },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            barHeight: "70%",
          },
        },
        colors: ["#ff4d4f"],
        dataLabels: {
          enabled: true,
          formatter: (val) => this.compact(val),
        },
        xaxis: {
          categories: this.labels,
          labels: {
            formatter: (val) => this.compact(val),
          },
        },
        yaxis: {
          labels: {
            maxWidth: 220,
            style: { fontSize: "11px" },
          },
        },
        tooltip: {
          y: {
            formatter: (val) => Number(val).toLocaleString() + ` ${this.currency}`,
          },
        },
      };
    },
  },
  methods: {
    formatLabel(name) {
      if (name == null || name === "") return this.$t("financialStats.otherCategory");
      const s = String(name);
      return s.length > 42 ? s.slice(0, 40) + "…" : s;
    },
    compact(val) {
      const n = Number(val);
      if (n >= 1e6) return (n / 1e6).toFixed(1) + "M";
      if (n >= 1e3) return (n / 1e3).toFixed(1) + "K";
      return n.toFixed(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-title {
  font-weight: 600;
  margin-bottom: 0;
}
</style>
